module.exports = __webpack_public_path__ + "static/media/Capture-removebg-preview.82251757.png";